module.exports = __webpack_public_path__ + "img/compass.c79d3ac.svg";